import React, {Component} from 'react';
import {forEach, find, filter, get, findIndex} from 'lodash';
import {Empty, Button, Checkbox, Col, Input, Row, Table} from "antd";
import consts, {PREFIX_FRONT_URL} from "../consts";
import {Link} from "react-router-dom";
import {EyeOutlined, EyeInvisibleOutlined} from "@ant-design/icons/lib/icons";
import MaskComponent from "./common/MaskComponent";
import FloatLabelInputComponent from "./common/FloatLabelInputComponent";
import {Translation} from "react-i18next";
import EncodedDataImage from "./common/EncodedDataImage"
import utils from "../common/utils";
import BigNumber from "bignumber.js";

class AccountBalanceComponent extends Component {
  columns = (t) => {
    return [
      {
        title: t('user.account_balance.coin'),
        width: 150,
        dataIndex: 'coin',
        key: 'coin',
        render: (coin) => <div className='d-flex align-items'>
          <div className='mr-medium'>{this.props.coins[coin] ?
            <EncodedDataImage coinInfo={this.props.coins[coin] || {}}/> : ''}</div>
          <div className="bold">{`${coin}`.toUpperCase()}</div>
        </div>
      },
      {
        title: t('user.account_balance.name'),
        width: 150,
        dataIndex: 'coin',
        key: 'coin',
        render: (coin) => `${window._.get(this.props.setting, `coins[${coin}].name`, '')}`,
      },
      {
        title: t('user.account_balance.balance'),
        width: 150,
        dataIndex: 'balance',
        key: 'balance',
        render: (balance) => <MaskComponent mask={!this.state.show}>
          {utils.formatCurrency(balance)}
        </MaskComponent>
      },
      {
        title: t('user.account_balance.available_balance'),
        width: 200,
        dataIndex: 'available_balance',
        key: 'available_balance',
        render: (availableBalance) => <MaskComponent mask={!this.state.show}>
          {utils.formatCurrency(availableBalance)}
        </MaskComponent>
      },
      {
        title: t('user.account_balance.action'),
        width: 200,
        key: 'coin',
        dataIndex: 'coin',
        render: (coin) => <div>
          <Link to={`${PREFIX_FRONT_URL}/${window.c.routes.DEPOSIT}?coin=${coin}`}
                className="link mr-small">{t('user.account_balance.deposit')}</Link>
          <Link to={`${PREFIX_FRONT_URL}/${window.c.routes.WITHDRAW}?coin=${coin}`}
                className="link">{t('user.account_balance.withdrawal')}</Link>
        </div>
      },
    ];
  };
  
  constructor(props) {
    super(props);
    this.state = {
      coins: {},
      show: false,
      params: {
        search: '',
      },
      checked: false,
    }
    this.getTotalBTCBalance = this.getTotalBTCBalance.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.useQuery = this.useQuery.bind(this);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      coins: nextProps.coins
    })
  }
  
  useQuery() {
    return new URLSearchParams(this.props.history.location.search);
  }
  
  onSearchInputChange({target}) {
    this.setState({params: {...this.state.params, search: target.value || ''}});
  }
  
  getTotalBTCBalance() {
    let mapCurrencyMarkets = this.props.setting.mapCurrencyMarkets;
    let balances = this.props.balances;
    let filterBalances = {}
    let sumBalance = new BigNumber(0);
    
    forEach(Object.keys(balances), (symbol) => {
      if (balances[symbol].available_balance !== 0) {
        filterBalances[symbol] = balances[symbol]
      }
    })
    
    forEach(Object.keys(filterBalances), (coin) => {
      let checkCoinHaveLastPrice = false;
      let currencyMarket = get(mapCurrencyMarkets, `USDT.${coin}`, false);
      if (currencyMarket) {
        sumBalance = sumBalance.plus(new BigNumber(filterBalances[coin].available_balance).times(currencyMarket.last_price))
        checkCoinHaveLastPrice = true;
      } else {
        let coins = filter(this.props.setting.coinSettings, (coinSetting) => coinSetting.coin === coin);
        
        for (let i = 0; i < coins.length; i++) {
          let {coin, currency} = coins[i];
          let currencyMarket = get(mapCurrencyMarkets, `${currency}.${coin}`, false);
          if (currencyMarket) {
            sumBalance = sumBalance.plus(new BigNumber(filterBalances[coin].available_balance)
              .times(currencyMarket.last_price)
              .times(get(mapCurrencyMarkets, `USDT.${currency}.last_price`, 1)));
  
            checkCoinHaveLastPrice = true;
            break;
          }
        }
      }
      
      if (checkCoinHaveLastPrice === false) {
        sumBalance = sumBalance.plus(filterBalances[coin].available_balance)
      }
    })
    
    sumBalance = sumBalance.plus(filterBalances['USDT']?.available_balance || 0)
    
    return sumBalance.toNumber()
  }
  
  getBTCBalance() {
    let currencyMarket = find(this.props.setting.currencyMarkets["USDT"], (currencyMarket) => currencyMarket.coin === "BTC");
    return this.getTotalBTCBalance() / currencyMarket?.last_price;
  }
  
  toggleShowHide() {
    this.setState({show: !this.state.show});
  }
  
  // filterResult = () => {
  //   let coins = window._.filter([...window._.values(this.props.balances)], ({coin, balance}) => {
  //     return coin.toLowerCase().includes(this.state.params.search.toLowerCase()) && (!this.state.checked || (this.state.checked && balance > 0));
  //   });
  //   const posETH = findIndex(coins, ({ coin }) => coin === 'ETH');
  //   const posBTC = findIndex(coins, ({ coin }) => coin === 'BTC');
  //
  //   let newCoins = filter(coins, (coin, i) => i !== posETH && i !== posBTC);
  //
  //   return [coins[posBTC], coins[posETH], ...newCoins];
  // };
  
  filterResult = () => window._.filter([...window._.values(this.props.balances)], ({coin, balance}) => {
    return coin.toLowerCase().includes(this.state.params.search.toLowerCase()) && (!this.state.checked || (this.state.checked && balance > 0));
  });
  
  render() {
    return (
      <Translation>
        {(t) => <>
          <div className="wallet-right-content justify-unset">
            {t('user.account_balance.account')}
            <Button className="ml-small v-middle br-5 text-normal"
                    icon={this.state.show ? <EyeInvisibleOutlined/> : <EyeOutlined/>}
                    onClick={() => this.toggleShowHide()}>
                      <span className="fontW-700">{this.state.show ? t('Hide') : t('Show')}</span>
            </Button>
          </div>
          <div className="account-balance-wrap user-wallet">
            <div className="balance-header text-left user-wallet-header">
              <Row>
                <Col span={12} >
                  <div className="user-wallet-header-1">
                    {t('user.account_balance.estimated_value')}:
                  </div>
                  <div>
									<span className="fz-32"><MaskComponent mask={!this.state.show}>
										{utils.formatCurrency(this.getBTCBalance())}
									</MaskComponent> </span>
                    {this.state.show ?
                      <span className='text-normal text-grey'> BTC ≈ ${utils.formatCurrency(this.getTotalBTCBalance())} </span> : '*******'}
                  </div>
                </Col>
                <Col span={12} >
                  <div className="user-wallet-header-1">
                    {t('user.account_balance.24h_limit')}
                  </div>
                  <div>
									<span className="fz-32" >0</span> / <span className='text-normal'>{t('user.account_balance.unlimited')}</span>
                    
                    {/*<span className='text-normal'> BTC / 2 BTC</span>*/}
                  </div>
                </Col>
              </Row>
            </div>
            <div className="balance-body user-wallet-body">
              <div className="text-left mt-medium text-black fz-14 w-auto mb-small clearfix">
                <div className="fll user-wallet-body-1">
                  <FloatLabelInputComponent label={`${t('user.account_balance.coin_search')}...`}
                                            width={200} className="user-wallet-body-1-input"
                                            value={this.state.params.search}
                                            onChange={(e) => this.onSearchInputChange(e)}/>
                </div>
                <div className="ml-small fll v-middle mt-ex-small">
                  <Checkbox style={{color: '#474D57'}} className='text-normal'
                            onChange={({target: {checked}}) => this.setState({checked})}>
                    {t('user.account_balance.hide_assets')}
                  </Checkbox>
                </div>
              </div>
              <Table columns={this.columns(t)}
                     locale={{
                       emptyText: (<Empty description={<span className="bold">{window.$t('common.empty')}</span>}/>)
                     }}
                     pagination={{
                       pageSize: 6,
                     }}
                // loading={this.props.params.isTableLoading}
                     dataSource={this.filterResult()}
                     className="mt-small user-wallet-body-table"
              />
            </div>
          </div>
        </>}
      </Translation>
    );
  }
}

export default AccountBalanceComponent;
